<template>
    <div v-show="show" class="auditProcess-container">
        <div v-if="type == 'normal'" class="auditProcess-content">
            <div @click="close" class="close"></div>
            <div class="title">审核流程配置</div>
            <div class="account">
                <div>
                    <p>当前栏目/账号：</p>
                    <span>{{ info.title }}</span>
                </div>
                <div v-show="nowList.length > 0" @click="newList" class="newBtnList"><i></i>新建审核流程</div>
            </div>
            <div class="setList">
                <!-- <div class="select">
                    <p @click="nowIndex = 0">通用配置</p>
                    <p @click="nowIndex = 1">自定义配置</p>
                    <div :class="{tag: true, on: nowIndex == 1}"></div>
                </div> -->
                <div v-if="nowIndex == 0" class="content">
                    <ul>
                        <li class="normal">
                            <p class="t">配置审核流程：</p>
                            <ul>
                                <li>
                                    <p @click="processIndex = 0" class="normalSelect"><i :class="{on: processIndex == 0}"></i>仅编辑</p>
                                    <p @click="processIndex = 1" class="normalSelect"><i :class="{on: processIndex == 1}"></i>一审</p>
                                    <p @click="processIndex = 2" class="normalSelect"><i :class="{on: processIndex == 2}"></i>二审</p>
                                    <p @click="processIndex = 3" class="normalSelect"><i :class="{on: processIndex == 3}"></i>三审</p>
                                </li>
                                <li v-show="processIndex == 0">
                                    <p class="tips">文稿将在编辑提交后直接发布</p>
                                </li>
                                <li>
                                    <p @click="processIndex = 9999" class="customSelect"><i :class="{on: processIndex == 9999}"></i>自定义</p>
                                    <div v-show="processIndex == 9999" class="num"><input v-model="customNum" @input="onlyNum" type="text">审</div>
                                    <p v-show="processIndex == 9999" class="tips">请输入大于3的整数</p>
                                </li>
                            </ul>
                        </li>
                        <li class="spe">
                            <p class="t">特殊审核流程：</p>
                            <ul>
                                <li>
                                    <p @click="isJump = !isJump" class="specSelect"><i :class="{select: true, on: isJump}"></i>跳审<i class="question"><span class="bg">审核角色发布的稿件将跳过自己的审核环节</span></i></p>
                                    <p @click="isAudit = !isAudit" class="specSelect"><i :class="{select: true, on: isAudit}"></i>审核隔离<i class="question"><span class="bg">同一稿件的审核用户不可重复</span></i></p>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div v-if="nowIndex == 1" :class="{content: true, on: nowList.length > 0}">
                    <ul v-if="nowList.length > 0">
                        <li>
                            <!-- <p class="t l">自定义配置:</p> -->
                            <div class="customList">
                                <ul>
                                    <li :class="{on: item.isSelected}" @click="selected(item, index)" v-for="(item, index) in nowList" :key="item.id"><div class="l"><i :class="{on: item.isSelected}"></i><span>{{ item.title }}</span></div><div class="r"><span @click.stop="editAudit(item.id, item.isSelected)">编辑</span><i @mouseenter="mouse" :class="{on: true}"><div :style="'top:'+pageY+'px'"><p @click.stop="addMinNumber(item.id, item.isSelected)">最小审核人数</p><p @click.stop="reName(item.title, item.id)">重命名</p><p @click.stop="del(item.title, item.id)">删除</p></div></i></div></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    
                    <div v-if="nowList.length == 0" @click="newList" class="newBtn"><i></i>新建审核流程</div>
                </div>
            </div>
            <div class="btns">
                <div @click="saveVerify" class="btn g">确定</div>
                <div @click="close" class="btn">取消</div>
            </div>
        </div>
        <div v-if="type == 'edit' || type == 'new' || type == 'check'" class="editAuditProcess">
            <div @click="closeBox" class="close"></div>
            <div class="title">{{type == 'new' ? '新建' : '编辑'}}审核流程</div>
            <div class="content">
                <div class="l">
                    <div class="name">
                        <div class="t red">名称：</div>
                        <input :disabled="info.type == 'check'" v-model="auditName" maxlength="40" placeholder="请输入自定义流程名称" type="text">
                    </div>
                    <div v-if="auditList.length > 0" class="step">
                        <p class="t"><span>跳审节点<i><span class="bg">审核⾓⾊发布的稿件将跳过⾃⼰审核的环节</span></i></span><span v-if="isJumpStep">跳审次数<i><span class="bg">默认值，可修改</span></i></span></p>
                        <div class="jump">
                            <div v-if="info.type == 'check'" :class="{switch: true, un: !isJumpStep}">
                                <i></i>
                            </div>

                            <div v-if="info.type != 'check'" @click="isJumpStep = !isJumpStep" :class="{switch: true, un: !isJumpStep}">
                                <i></i>
                            </div>

                            <div v-if="isJumpStep" :class="{select: true, on: showJumpStepList}">
                                <p v-if="info.type == 'check'">{{ JumpStepList[JumpStepIndex] }}</p><i v-if="info.type == 'check'" :class="{on: showJumpStepList}"></i>
                                <p v-if="info.type != 'check'" @click="showJumpStepList = !showJumpStepList">{{ JumpStepList[JumpStepIndex] }}</p><i v-if="info.type != 'check'" :class="{on: showJumpStepList}" @click="showJumpStepList = !showJumpStepList"></i>
                                <ul v-click-outside="closeJumpStepList" v-if="showJumpStepList">
                                    <li @click="JumpStepIndex = index;showJumpStepList = false" v-for="(item, index) in JumpStepList" :key="index"><p>{{ item }}</p><i></i></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="r">
                    <ul>
                        <li class="edit">
                            <div class="c">
                                <div class="n">编辑</div>
                                <div class="empty"></div>
                            </div>
                        </li>
                        <li :class="{on: selectIndex == index}" @click="selectIndex = index" v-for="(item, index) in auditList" :key="index">
                            <div class="c">
                                <div class="n">{{ auditArr[index] }}</div>
                                <div v-if="info.type == 'check'" class="col">
                                    <p class="t">退回至</p>
                                    <div :class="{select: true, on: item.showBack}">
                                        <p>{{ item.backList[item.backIndex].name }}</p><i :class="{on: item.showBack}"></i>
                                        <div v-show="item.showBack">
                                            <div class="spare"></div>
                                            <ul>
                                                <li v-for="(val,key) in item.backList" :key="key"><p>{{ val.name }}</p><i :class="{on: item.backIndex == key}"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="info.type != 'check'" class="col">
                                    <p class="t">退回至</p>
                                    <div @mouseover="item.showBack = true" @mouseout="item.showBack = false" :class="{select: true, on: item.showBack}">
                                        <p>{{ item.backList[item.backIndex].name }}</p><i :class="{on: item.showBack}" @click="item.showBack = !item.showBack"></i>
                                        <div v-show="item.showBack">
                                            <div class="spare"></div>
                                            <ul>
                                                <li v-for="(val,key) in item.backList" :key="key" @click="item.backIndex = key;item.showBack = false"><p>{{ val.name }}</p><i :class="{on: item.backIndex == key}"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="info.type == 'check'" class="col">
                                    <p class="t">隔离审核<span>(可多选)</span></p>
                                    <div :class="{select: true, on: item.showAudit}">
                                        <p>{{ item.auditTitle }}</p><i :class="{on: item.showAudit}"></i>
                                        <div v-show="item.showAudit">
                                            <div class="spare"></div>
                                            <ul>
                                                <li v-for="(val,key) in item.auditList" :key="key"><p>{{ val.name }}</p><i :class="{on: val.isSelected}"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="info.type != 'check'" class="col">
                                    <p class="t">隔离审核<span>(可多选)</span></p>
                                    <div @mouseover="item.showAudit = true" @mouseout="item.showAudit = false" :class="{select: true, on: item.showAudit}">
                                        <p>{{ item.auditTitle }}</p><i :class="{on: item.showAudit}" @click="item.showAudit = !item.showAudit"></i>
                                        <div v-show="item.showAudit">
                                            <div class="spare"></div>
                                            <ul>
                                                <li @click="setAuditIndex(item, val)" v-for="(val,key) in item.auditList" :key="key"><p>{{ val.name }}</p><i :class="{on: val.isSelected}"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="isJumpStep" class="row">
                                    <div class="t">可跳审</div>
                                    <div v-if="info.type == 'check'" :class="{switch: true, un: !item.isJump}"><i></i></div>
                                    <div v-if="info.type != 'check'" @click="item.isJump = !item.isJump" :class="{switch: true, un: !item.isJump}"><i></i></div>
                                </div>
                            </div>
                            <img @click="delAudit(index)" v-if="index == auditList.length - 1 && info.type != 'check'" src="./assets/bin.png" alt="">
                        </li>
                        <li v-if="auditList.length<10 && info.type != 'check'" class="new">
                            <i @click="newAudit"></i>
                            <span @click="newAudit">添加审核流程</span>
                        </li>
                    </ul>   
                </div>
            </div>
            <div v-show="info.type != 'check'" class="btns">
                <div @click="next" class="btn g">保存</div>
                <div @click="closeBox" class="btn">取消</div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import * as config from '@common/config'
import vClickOutside from "v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            pageY: 0,
            saveTemplateId: '',
            id: '',
            type: 'normal',
            show: false,
            info: {
                type: 'normal'
            },
            callback: null,
            nowIndex: 1,
            processIndex: 0,
            customNum: 4,
            isJump: false,
            isAudit: false,
            isJumpStep: false,
            showJumpStepList: false,
            JumpStepIndex: 0,
            JumpStepList: [],
            auditName: '',
            selectIndex: 0,
            nowList: [],
            auditList: [],
            auditArr: ['一审','二审','三审','四审','五审','六审','七审','八审','九审','十审']
        }
    },
    watch: {
        auditList(){
            let arr = []
            for (let index = this.auditList.length; index > 0; index--) {
                arr.push(index)
            }
            this.JumpStepList = arr
        },
        isJumpStep(){
            this.auditList.forEach(el => {
                el.isJump = true
            })
        }
    },
    methods: {
        closeBox() {
            window.close()
        },
        mouse(i) {
            this.pageY = i.y - this.saveY
            console.log(i)
        },
        newList() {
            this.auditName = '';
            this.isJumpStep = false;
            this.JumpStepIndex = 0;
            this.JumpStepList = [];
            this.selectIndex = 0;
            this.auditList = [];
            this.type = 'new'
        },
        saveVerify() {
            let id = ''
            this.nowList.forEach(el => {
                if(el.isSelected){
                    id = el.id
                }
            })
            if(id){
                if(this.saveTemplateId!='' && this.saveTemplateId != id){
                    this.$auditDialog({type: 'notice', title: '温馨提示', content1: '当前操作将同步前台配置，是否确定?', content2: '', btn1: '确定启用', btn2: '我再想想'}).then(res => {
                        if(res){
                            let info = {
                                template_id: id,
                                platform_key: this.info.platform_key,
                                column_key: this.info.column_key
                            }

                            common
                            .myFetch(apis.adminsaveVerify, {data: info})
                            .then(r => {
                                if (r) {
                                    this.$toast('操作成功')
                                    this.callback(true)
                                    this.show = false
                                }
                            });  
                        }
                    })
                }else{
                    let info = {
                        template_id: id,
                        platform_key: this.info.platform_key,
                        column_key: this.info.column_key
                    }

                    common
                    .myFetch(apis.adminsaveVerify, {data: info})
                    .then(r => {
                        if (r) {
                            this.$toast('操作成功')
                            this.callback(true)
                            this.show = false
                        }
                    });  
                }
            }else{
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '请选择审核流程模板', content2: '', btn1: '确定', btn2: ''})
            }
        },
        del(name, id) {
            this.$auditDialog({type: 'notice', title: '温馨提示', content1: '确认删除该配置：<span>'+name+'</span>', content2: '', btn1: '确定删除', btn2: '我再想想'}).then(res => {
                if(res){
                    let info = {
                        template_id: id
                    }

                    common
                    .myFetch(apis.admindelVerifyTemplate, {data: info})
                    .then(r => {
                        if (r) {
                            this.$toast('删除成功')
                            this.getList()
                        }
                    });
                }
            })
        },
        addMinNumber(id, isSelected) {
            this.$auditDialog({type: 'addMin', id: id, title: '参与审核最小人数', content1: '', content2: '', btn1: '保存', btn2: '取消'}).then(res => {
                if(res){
                    let info = {
                        min_users_count: res,
                        template_id: id
                    }

                    common
                    .myFetch(apis.adminsetMinVerifyNum, {data: info})
                    .then(r => {
                        if (r) {
                            this.$toast('参与审核最小人数修改成功')
                            this.getList()
                        }
                    });
                }
            })
        },
        reName(name, id) {
            this.$auditDialog({type: 'reName', name: name, title: '重命名', content1: '', content2: '', btn1: '确定修改', btn2: '取消'}).then(res => {
                if(res){
                    let info = {
                        title: res,
                        template_id: id
                    }

                    common
                    .myFetch(apis.setVerifyTitle, {data: info})
                    .then(r => {
                        if (r) {
                            this.$toast('重命名成功')
                            this.getList()
                        }
                    });
                }
            })
        },
        selected(item,index) {
            this.nowList.forEach((val, key) => {
                if(key != index){
                    val.isSelected = false
                }
            })

            item.isSelected = true
        },
        save() {
            let nodes = [{
                node_id: 0,
                reject_to: '',
                isolate_nodes: [],
                is_jump: ''
            }]
            this.auditList.forEach((el, index) => {
                let arr = []
                el.auditList.forEach((val, key) => {
                    if(val.isSelected && key != 0){
                        arr.push(key - 1)
                    }
                })
                nodes.push({
                    node_id: index + 1,
                    reject_to: el.backIndex,
                    isolate_nodes: JSON.stringify(arr),
                    is_jump: el.isJump ? 1 : 0
                })
            })

            let info = {
                template_id: this.type == 'edit' ? this.id : 0,
                title: this.auditName,
                node_count: this.auditList.length + 1,
                jump_count: this.isJumpStep ? this.JumpStepList[this.JumpStepIndex] : 0,
                nodes: JSON.stringify(nodes)
            }

            common
            .myFetch(apis.adminsaveVerifyTemplate, {data: info, hideLoading: true})
            .then(r => {
                if (r) {
                    this.$toast(r.msg)
                    this.getList()
                    this.type = 'normal'
                    // console.log(r)
                }
            });
            // console.log(info)
        },
        editAudit(id, isSelected) {
            this.$auditDialog({type: 'notice', title: '温馨提示', content1: '该修改将同步至所有使用该配置的栏目', content2: '', btn1: '确定修改', btn2: '我再想想'}).then(res => {
                if(res){
                    this.type = 'edit'
                    this.id = id;
                    this.getVerifyTemplate(id)
                }
            })
        },
        next() {
            if(this.auditName){
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '该修改将同步至所有使用该配置的栏目', content2: '', btn1: '确定修改', btn2: '我再想想'}).then(res => {
                    if(res){
                        this.save()
                    }
                })
            }else{
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '当前自定义流程名称未填写！', content2: '', btn1: '确定', btn2: ''})
            }
        },
        setAuditIndex(item, val) {
            if(val.name == '无'){
                item.auditList.forEach(el => {
                    el.isSelected = false;
                })
                item.auditList[0].isSelected = true;
                item.auditTitle = '无'
            }else{
                item.auditList[0].isSelected = false;
                val.isSelected = !val.isSelected;
                let arr = [];
                item.auditList.forEach(el => {
                    if(el.isSelected){
                        arr.push(el.name)
                    }
                })
                if(arr.length > 0){
                    item.auditTitle = arr.join(',')
                }else{
                    item.auditTitle = '无'
                    item.auditList[0].isSelected = true;
                }
                
            }
        },
        closeJumpStepList() {
            this.showJumpStepList = false
        },
        delAudit(key) {
            if(this.JumpStepIndex != 0){
                this.JumpStepIndex --
            }
            this.auditList = this.auditList.filter((el, index) => {
                return key != index
            })
        },
        newAudit() {
            let backList = [{name: '编辑', isSelected: true}]
            let auditList = [{name: '无', isSelected: true},{name: '编辑', isSelected: false}]
            if(this.auditList.length == 0){
                this.auditList.push({
                    isJump: true,
                    showBack: false,
                    showAudit: false,
                    backIndex: 0,
                    backList: backList,
                    auditIndex: 0,
                    auditTitle: '无',
                    auditList: auditList
                })
            }else{
                for (let index = 0; index < this.auditList.length; index++) {
                    backList.push({
                        name: this.auditArr[index],
                        isSelected: false
                    })

                    auditList.push({
                        name: this.auditArr[index],
                        isSelected: false
                    })
                }
                if(this.JumpStepIndex != 0){
                    this.JumpStepIndex ++ 
                }
                this.auditList.push({
                    isJump: true,
                    showBack: false,
                    showAudit: false,
                    backIndex: 0,
                    backList: backList,
                    auditIndex: 0,
                    auditTitle: '无',
                    auditList: auditList
                })
            }
        },
        onlyNum() {
            let customNum = this.customNum
            customNum = customNum.replace(/[^\d]/g,'')
            if(customNum === '0' ||customNum === 0 || customNum == 1 || customNum == 2 || customNum == 3 || customNum > 10){
                customNum = 4
            }
            this.customNum = customNum
        },
        open(info, callback) {
            this.info = info;
            this.callback = callback;
            this.show = true;
            if(info.type == 'normal'){
                this.getList()
            }else{
                this.type = info.type
                this.id = info.id;
                this.getVerifyTemplate(info.id)
                // this.editAudit(info.id)
            }
            
            for (let index = this.auditList.length; index > 0; index--) {
                this.JumpStepList.push(index)
            }

            // this.$auditDialog()
        },
        confirm() {

        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            if(this.type == 'edit' || this.type == 'new'){
                this.type = 'normal'
            }else{
                this.cancel()
            }
        },
        getVerifyTemplate(id) {
            this.auditName = ''
            this.isJumpStep = false;
            this.JumpStepIndex = 0;
            this.JumpStepList = [];
            this.auditList = [];

            let info = {
                template_id: id
            }

            common
            .myFetch(apis.admingetVerifyTemplate, {data: info})
            .then(r => {
                if (r) {
                    // console.log(r)
                    r.nodes.splice(0,1);
                    this.auditName = r.title;
                    this.isJumpStep = r.jump_count == 0 ? false : true;
                    this.$nextTick(() => {
                        if(r.nodes.length == 0) return
                        r.nodes.forEach((el,index) => {
                            let backList = []
                            let auditList = []
                            let auditTitleArr = []
                            if(index == 0){
                                auditTitleArr = []
                                backList = [{name: '编辑', isSelected: true}]
                                auditList = [{name: '无', isSelected: true},{name: '编辑', isSelected: false}]
                                
                                backList.forEach((val,key) => {
                                    if(el.reject_to == key){
                                        val.isSelected = true
                                    }else{
                                        val.isSelected = false
                                    }
                                })

                                if(typeof(el.isolate_nodes) === "string"){
                                    el.isolate_nodes = JSON.parse(el.isolate_nodes)
                                }
                                
                                if(el.isolate_nodes.length > 0){
                                    auditList.forEach((val,key) => {
                                        val.isSelected = false
                                    })
                                    el.isolate_nodes.forEach(el1 => {
                                        auditList.forEach((val,key) => {
                                            if(el1+1 == key){
                                                val.isSelected = true
                                                auditTitleArr.push(val.name)
                                            }
                                        })
                                    })
                                }else{
                                    auditList.forEach((val,key) => {
                                        if(key == 0){
                                            val.isSelected = true
                                            auditTitleArr.push(val.name)
                                        }else{
                                            val.isSelected = false
                                        }
                                    })
                                }
                            }else{
                                auditTitleArr = []
                                backList = [{name: '编辑', isSelected: true}]
                                auditList = [{name: '无', isSelected: true},{name: '编辑', isSelected: false}]
                                
                                for (let index = 0; index < this.auditList.length; index++) {
                                    backList.push({
                                        name: this.auditArr[index],
                                        isSelected: false
                                    })

                                    auditList.push({
                                        name: this.auditArr[index],
                                        isSelected: false
                                    })
                                }

                                backList.forEach((val,key) => {
                                    if(el.reject_to == key){
                                        val.isSelected = true
                                    }else{
                                        val.isSelected = false
                                    }
                                })

                                if(typeof(el.isolate_nodes) === "string"){
                                    el.isolate_nodes = JSON.parse(el.isolate_nodes)
                                }

                                if(el.isolate_nodes.length > 0){
                                    auditList.forEach((val,key) => {
                                        val.isSelected = false
                                    })
                                    el.isolate_nodes.forEach(el1 => {
                                        auditList.forEach((val,key) => {
                                            if(el1+1 == key){
                                                val.isSelected = true
                                                auditTitleArr.push(val.name)
                                            }
                                        })
                                    })
                                }else{
                                    auditList.forEach((val,key) => {
                                        if(key == 0){
                                            val.isSelected = true
                                            auditTitleArr.push(val.name)
                                        }else{
                                            val.isSelected = false
                                        }
                                    })
                                }
                            }

                            this.auditList.push({
                                isJump: el.is_jump == 1 ? true : false,
                                showBack: false,
                                showAudit: false,
                                backIndex: el.reject_to,
                                backList: backList,
                                auditIndex: 0,
                                auditTitle: auditTitleArr.join(','),
                                auditList: auditList
                            })
                        })

                        this.$nextTick(() => {
                            if(r.jump_count > 0){
                                this.JumpStepList.forEach((el,key) => {
                                    if(el == r.jump_count){
                                        this.JumpStepIndex = key
                                    }
                                })
                            }
                        })
                    })
                }
            });
        },
        getList() {
            console.log(this.info)
            let info = {
                platform_key: this.info.platform_key,
                column_key: this.info.column_key
            }

            common
            .myFetch(apis.adminverifyTemplateList, {data: info, hideLoading: true})
            .then(r => {
                if (r) {
                    console.log(r)
                    r.forEach(el => {
                        if(el.isSelected){
                            this.saveTemplateId = el.id
                        }
                    })
                    this.nowList = r

                    this.$nextTick(() => {
                        let setList = document.querySelectorAll('.auditProcess-content .setList')[0]
                        this.saveY = setList.getBoundingClientRect().y
                    })
                }
            });
        }
    }
}
</script>

<style lang="less">
    .auditProcess-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .editAuditProcess {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 1080px;
            padding: 40px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
            border-radius: 4px;

            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/close.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            .title {
                margin: 0 auto 30px;
                font-size: 20px;
                font-weight: 500;
                color: #050F0F;
                line-height: 28px;
                text-align: center;
            }

            .content {
                display: flex;

                .l {
                    display: flex;
                    flex-direction: column;
                    margin-right: 60px;

                    .name {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 30px;

                        .t {
                            font-size: 14px;
                            line-height: 20px;
                            color: #050F0F;            
                            font-weight: bold;

                            &.red {
                                display: flex;
                                margin-bottom: 14px;

                                &::before {
                                    display: inline-block;
                                    content: '*';
                                    font-size: 24px;
                                    line-height: 24px;
                                    color: #FF555A;
                                }
                            }
                        }

                        input {
                            width: 180px;
                            height: 32px;
                            background: #F3F5F6;
                            border-radius: 2px;
                            outline: none;
                            padding: 0 14px;
                            box-sizing: border-box;

                            &::placeholder {
                                font-size: 14px;
                                color: #C4CBD1;
                            }
                        }
                    }

                    .step {
                        display: flex;
                        flex-direction: column;

                        .t {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 14px;
                            line-height: 20px;
                            color: #050F0F;            
                            font-weight: bold;
                            margin-bottom: 21px;

                            &>span {
                                position: relative;
                            }

                            .bg {
                                position: absolute;
                                left: 33px;
                                top: -38px;
                                display: none;
                                align-items: center;
                                justify-content: center;
                                padding: 0 10px;
                                box-sizing: border-box;
                                width: fit-content;
                                min-width: 112px;
                                height: 32px;
                                line-height: 32px;
                                text-align: center;
                                background: rgba(5,15,15,0.8);
                                border-radius: 4px;
                                font-size: 12px;
                                color: #FFFFFF;
                                font-weight: normal;
                                white-space: nowrap;
                            }

                            span {
                                display: flex;
                                align-items: center;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('./assets/question.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-left: 4px;
                                    user-select: none;
                                    cursor: pointer;

                                    &:hover {
                                        background: url('./assets/questionOn.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;

                                        .bg {
                                            display: flex;
                                        }
                                    }
                                }
                            }
                        }

                        .jump {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                        }

                        div.switch {
                            display: flex;
                            align-items: center;
                            width: 44px;
                            height: 22px;
                            background: #41B48C;
                            border-radius: 11px;
                            user-select: none;
                            cursor: pointer;

                            &.un {
                                background: #CED3D7;

                                i {
                                margin-left: 2px;
                                transition: margin-left 0.3s;
                                }
                            }

                            i {
                                display: block;
                                width: 18px;
                                height: 18px;
                                background: #FFFFFF;
                                border-radius: 50%;
                                margin-left: 24px;
                                transition: margin-left 0.3s;
                            }
                        }

                        .select {
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 74px;
                            height: 32px;
                            background: rgba(185,195,195,0.2);
                            border-radius: 2px;
                            padding: 0 18px 0 20px;
                            border: 1px solid transparent;
                            box-sizing: border-box;

                            &.on {
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                            }

                            p {
                                flex: 1;
                                min-width: 0;
                                font-size: 14px;
                                color: #323B4B;
                                line-height: 32px;
                                user-select: none;
                                cursor: pointer;
                            }

                            & > i {
                                display: block;
                                width: 12px;
                                height: 8px;
                                background: url('./assets/arrow.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                transform: rotate(180deg);
                                user-select: none;
                                cursor: pointer;
                                margin-left: 5px;

                                &.on {
                                    transform: rotate(0deg);
                                }
                            }

                            ul {
                                position: absolute;
                                top: 40px;
                                left: 0;
                                z-index: 99;
                                width: 74px;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
                                border-radius: 4px;

                                li {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    text-align: center;
                                    padding: 0 16px 0 20px;
                                    box-sizing: border-box;
                                    &:hover {
                                        background: rgba(65,180,140,0.15);
                                    }

                                    p {
                                        font-size: 14px;
                                        line-height: 30px;
                                        color: #050F0F;
                                        text-align: left;
                                    }

                                    i.on {
                                        width: 14px;
                                        height: 11px;
                                        background: url('./assets/gou.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }
                        }
                    }
                }

                .r {
                    flex: 1;
                    min-width: 0;
                    & > ul {
                        display: flex;
                        padding-bottom: 20px;
                        overflow-x: auto;

                        &::-webkit-scrollbar {
                            height: 6px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background: rgba(185, 195, 195, 0.5);
                            border-radius: 6px;
                        }

                        & > li {
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                            min-width: 210px;
                            height: 438px;
                            border: 1px solid #E1E1E1;
                            box-sizing: border-box;
                            margin-right: 14px;
                            padding: 20px 30px;
                            box-sizing: border-box;

                            &.edit {
                                padding: 20px 0;
                                box-sizing: border-box;

                                .n {
                                    padding: 0 30px;
                                    box-sizing: border-box;

                                    &::after {
                                        left: 0;
                                    }
                                }
                            }

                            &.on {
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                            }

                            &.new {
                                justify-content: center;
                                border: none;
                                background: rgba(241,243,244,0.4);

                                i {
                                    display: block;
                                    width: 22px;
                                    height: 22px;
                                    background: url('./assets/addIcon.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-bottom: 8px;
                                    user-select: none;
                                    cursor: pointer;
                                }

                                span {
                                    font-size: 13px;
                                    line-height: 18px;
                                    color: #666666;
                                    user-select: none;
                                    cursor: pointer;
                                }
                            }

                            .c {
                                display: flex;
                                flex-direction: column;   
                                width: 100%;
                            }

                            .n {
                                position: relative;
                                font-size: 20px;
                                line-height: 28px;
                                color: #41B48C;
                                font-weight: 500;
                                margin-bottom: 30px;

                                &::after {
                                    position: absolute;
                                    top: 5px;
                                    left: -30px;
                                    display: block;
                                    content: '';
                                    width: 4px;
                                    height: 18px;
                                    background: #41B48C;
                                }
                            }

                            .empty {
                                display: block;
                                width: 170px;
                                height: 114px;
                                background: url('./assets/empty.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin: 84px auto 0;
                            }

                            .col {
                                display: flex;
                                flex-direction: column;

                                .t {
                                    display: flex;
                                    align-items: center;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #050F0F;
                                    font-weight: bold;
                                    margin-bottom: 14px;

                                    span {
                                        font-size: 13px;
                                        color: #666666;
                                        margin-left: 6px;
                                        font-weight: normal;
                                    }
                                }

                                .select {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    width: 150px;
                                    height: 32px;
                                    background: rgba(185,195,195,0.2);
                                    border-radius: 2px;
                                    padding: 0 16px 0 20px;
                                    border: 1px solid transparent;
                                    box-sizing: border-box;
                                    margin-bottom: 30px;

                                    &.on {
                                        border: 1px solid #41B48C;
                                        box-sizing: border-box;
                                    }

                                    p {
                                        flex: 1;
                                        min-width: 0;
                                        font-size: 14px;
                                        color: #323B4B;
                                        line-height: 32px;
                                        user-select: none;
                                        cursor: pointer;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        overflow: hidden;
                                    }

                                    & > i {
                                        display: block;
                                        width: 12px;
                                        height: 8px;
                                        background: url('./assets/arrow.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        transform: rotate(180deg);

                                        &.on {
                                            transform: rotate(0deg);
                                        }
                                    }

                                    &>div {
                                        position: absolute;
                                        top: 30px;
                                        left: 0;
                                        z-index: 99;
                                        width: 150px;

                                        .spare {
                                            width: 100%;
                                            height: 8px;
                                        }
                                    }

                                    ul {
                                        width: 150px;
                                        max-height: 120px;
                                        background: #FFFFFF;
                                        box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
                                        border-radius: 4px;
                                        overflow: hidden;
                                        overflow-y: auto;

                                        &::-webkit-scrollbar {
                                            width: 4px;
                                        }
                                        &::-webkit-scrollbar-thumb {
                                            background: #ddd;
                                            border-radius: 4px;
                                        }

                                        li {
                                            display: flex;
                                            justify-content: space-between;
                                            align-items: center;
                                            width: 100%;
                                            height: 30px;
                                            line-height: 30px;
                                            text-align: center;
                                            padding: 0 16px 0 20px;
                                            box-sizing: border-box;
                                            &:hover {
                                                background: rgba(65,180,140,0.15);
                                            }

                                            p {
                                                font-size: 12px;
                                                line-height: 30px;
                                                color: #050F0F;
                                                text-align: left;
                                            }

                                            i.on {
                                                width: 14px;
                                                height: 11px;
                                                background: url('./assets/gou.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }
                                    }
                                }
                            }

                            .row {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;

                                .t {
                                    display: flex;
                                    align-items: center;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #050F0F;
                                    font-weight: bold;
                                    margin-bottom: 14px;

                                    span {
                                        font-size: 13px;
                                        color: #666666;
                                        margin-left: 6px;
                                        font-weight: normal;
                                    }
                                }

                                div.switch {
                                    display: flex;
                                    align-items: center;
                                    width: 44px;
                                    height: 22px;
                                    background: #41B48C;
                                    border-radius: 11px;
                                    user-select: none;
                                    cursor: pointer;

                                    &.un {
                                        background: #CED3D7;

                                        i {
                                        margin-left: 2px;
                                        transition: margin-left 0.3s;
                                        }
                                    }

                                    i {
                                        display: block;
                                        width: 18px;
                                        height: 18px;
                                        background: #FFFFFF;
                                        border-radius: 50%;
                                        margin-left: 24px;
                                        transition: margin-left 0.3s;
                                    }
                                }
                            }

                            img {
                                width: 24px;
                                height: 24px;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .btns {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 14px;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #FFFFFF;
                    user-select: none;
                    cursor: pointer;
                    font-weight: bold;

                    &.g {
                        background: #41B48C;
                        margin-right: 20px;
                    }
                }
            }
        }

        .auditProcess-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 658px;
            padding: 30px 30px 24px;
            box-sizing: border-box;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
            border-radius: 4px;

            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                display: block;
                width: 18px;
                height: 18px;
                background: url('./assets/close.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            .title {
                margin: 0 auto 30px;
                font-size: 20px;
                font-weight: 500;
                color: #050F0F;
                line-height: 28px;
                text-align: center;
            }

            .account {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 20px;
                box-sizing: border-box;

                div {
                    display: flex;
                    align-items: center;
                }

                p {
                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    font-weight: bold;
                    margin-right: 10px;
                }

                span {
                    font-size: 14px;
                    line-height: 20px;
                    color: #41B48C;
                    font-weight: bold;
                }

                .newBtnList {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 136px;
                    height: 30px;
                    background: rgba(65,180,140,0.15);
                    border-radius: 4px;
                    border: 1px solid rgba(65,180,140,0.4);
                    font-size: 14px;
                    font-weight: 500;
                    color: #41B48C;
                    user-select: none;
                    cursor: pointer;

                    i {
                        display: block;
                        width: 16px;
                        height: 16px;
                        margin-right: 8px;
                        background: url('./assets/add.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }
                }
            }

            .setList {
                display: flex;
                flex-direction: column;

                .select {
                    position: relative;
                    display: flex;
                    width: 100%;
                    height: 34px;

                    p {
                        position: relative;
                        z-index: 2;
                        font-size: 14px;
                        color: #050F0F;
                        font-weight: bold;
                        margin-left: 52px;
                        line-height: 34px;
                        user-select: none;
                        cursor: pointer;
                    }

                    .tag {
                        position: absolute;
                        bottom: 0;
                        left: 14px;
                        width: 132px;
                        height: 34px;
                        background: url('./assets/tag.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        transition: left 0.2s linear;

                        &.on {
                            left: 126px
                        }
                    }
                }

                .content {
                    position: relative;
                    width: 100%;
                    min-height: 242px;
                    background: rgba(185,195,195,0.15);
                    border-radius: 12px;
                    padding: 42px 20px 38px;
                    border-radius: 12px;
                    box-sizing: border-box;

                    &.on {
                        padding: 15px 0px;
                        box-sizing: border-box;
                        height: 242px;
                        max-height: 242px;

                        & > ul {
                            height: 100%;

                            & > li {
                                display: flex;
                                flex-direction: column;
                                height: 100%;
                            }
                        }
                    }

                    .newBtnList {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 136px;
                        height: 30px;
                        background: rgba(65,180,140,0.15);
                        border-radius: 4px;
                        border: 1px solid rgba(65,180,140,0.4);
                        font-size: 14px;
                        font-weight: 500;
                        color: #41B48C;
                        user-select: none;
                        cursor: pointer;
                        margin: 14px 0 0 112px;

                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            margin-right: 8px;
                            background: url('./assets/add.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }
                    }

                    .newBtn {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 136px;
                        height: 30px;
                        background: rgba(65,180,140,0.15);
                        border-radius: 4px;
                        border: 1px solid rgba(65,180,140,0.4);
                        font-size: 14px;
                        font-weight: 500;
                        color: #41B48C;
                        user-select: none;
                        cursor: pointer;

                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            margin-right: 8px;
                            background: url('./assets/add.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }
                    }

                    & > ul {
                        display: flex;
                        flex-direction: column;

                        & > li {
                            display: flex;
                            flex-direction: row;

                            &.normal {
                                margin-bottom: 22px;
                            }

                            .t {
                                font-size: 14px;
                                line-height: 20px;
                                font-weight: bold;
                                color: #050F0F;
                                margin-right: 7px;

                                &.l {
                                    letter-spacing: 4px;
                                    margin-right: 8px;
                                }
                            }

                            .customList {
                                // position: relative;
                                flex: 1;
                                min-width: 0;
                                height: 140px;
                                background: rgba(241,243,244,0.4);

                                ul {
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                    height: 100%;
                                    overflow-y: auto;

                                    &::-webkit-scrollbar {
                                        width: 6px;
                                    }
                                    &::-webkit-scrollbar-thumb {
                                        background: rgba(185, 195, 195, 0.5);
                                        border-radius: 6px;
                                    }

                                    li {
                                        display: flex;
                                        justify-content: space-between;
                                        width: 100%;
                                        height: 30px;
                                        font-size: 14px;
                                        line-height: 30px;
                                        padding: 0 20px 0 19px;
                                        box-sizing: border-box;
                                        cursor: pointer;

                                        &.on {
                                            background: rgba(185,195,195,0.15);

                                            .r {
                                                display: flex;
                                            }
                                        }

                                        &:hover {
                                            background: rgba(185,195,195,0.15);

                                            .r {
                                                display: flex;
                                            }
                                        }

                                        .l {
                                            display: flex;
                                            align-items: center;
                                            color: #050F0F;
                                            flex: 1;
                                            min-width: 0;

                                            i {
                                                display: block;
                                                width: 14px;
                                                height: 11px;
                                                margin-right: 13px;

                                                &.on {
                                                    background: url('./assets/gou.png') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                }
                                            }

                                            span {
                                                flex: 1;
                                                min-width: 0;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                white-space: nowrap;
                                                flex-wrap: nowrap;
                                            }
                                        }

                                        .r {
                                            display: none;
                                            align-items: center;
                                            color: #41B48C;

                                            i {
                                                display: block;
                                                width: 16px;
                                                height: 16px;
                                                margin-left: 6px;

                                                &.on {
                                                    // position: relative;
                                                    background: url('./assets/more.png') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;

                                                    &:hover {
                                                        background: url('./assets/moreOn.png') no-repeat;
                                                        background-position: center center;
                                                        background-size: 100% 100%;

                                                        div {
                                                            display: block;
                                                        }
                                                    }

                                                    div {
                                                        display: none;
                                                        position: absolute;
                                                        top: 16px;
                                                        // top: 0;
                                                        right: 0;
                                                        z-index: 9;
                                                        width: 92px;
                                                        background: rgba(0,0,0,0.8);
                                                        border-radius: 4px;
                                                        overflow: hidden;
                                                        padding: 0 10px;
                                                        box-sizing: border-box;

                                                        p {
                                                            width: 100%;
                                                            height: 32px;
                                                            line-height: 32px;
                                                            text-align: left;
                                                            font-size: 12px;
                                                            color: #FFFFFF;
                                                            user-select: none;
                                                            cursor: pointer;

                                                            &:hover {
                                                                color: #41B48C;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            & > ul {
                                display: flex;
                                flex-direction: column;

                                & > li {
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 10px;

                                    p.normalSelect {
                                        display: flex;
                                        align-items: center;
                                        user-select: none;
                                        cursor: pointer;
                                        font-size: 14px;
                                        line-height: 20px;
                                        font-weight: bold;
                                        color: #050F0F;
                                        margin-right: 80px;

                                        i {
                                            position: relative;
                                            width: 16px;
                                            height: 16px;
                                            border-radius: 8px;
                                            border: 1px solid #B9C3C3;
                                            margin-right: 10px;
                                            box-sizing: border-box;

                                            &.on {
                                                background: #41B48C;
                                                border: 1px solid #41B48C;
                                                box-sizing: border-box;

                                                &::after {
                                                    position: absolute;
                                                    top: 50%;
                                                    left: 50%;
                                                    transform: translate(-50%, -50%);
                                                    display: block;
                                                    content: '';
                                                    width: 6px;
                                                    height: 6px;
                                                    background: #FFFFFF;
                                                    border-radius: 20px;
                                                }
                                            }
                                        }
                                    }

                                    p.customSelect {
                                        display: flex;
                                        align-items: center;
                                        user-select: none;
                                        cursor: pointer;
                                        font-size: 14px;
                                        line-height: 20px;
                                        font-weight: bold;
                                        color: #050F0F;
                                        margin-right: 10px;

                                        i {
                                            position: relative;
                                            width: 16px;
                                            height: 16px;
                                            border-radius: 8px;
                                            border: 1px solid #B9C3C3;
                                            margin-right: 10px;
                                            box-sizing: border-box;

                                            &.on {
                                                background: #41B48C;
                                                border: 1px solid #41B48C;
                                                box-sizing: border-box;

                                                &::after {
                                                    position: absolute;
                                                    top: 50%;
                                                    left: 50%;
                                                    transform: translate(-50%, -50%);
                                                    display: block;
                                                    content: '';
                                                    width: 6px;
                                                    height: 6px;
                                                    background: #FFFFFF;
                                                    border-radius: 20px;
                                                }
                                            }
                                        }
                                    }

                                    p.specSelect {
                                        display: flex;
                                        align-items: center;
                                        user-select: none;
                                        cursor: pointer;
                                        font-size: 14px;
                                        line-height: 20px;
                                        font-weight: bold;
                                        color: #050F0F;
                                        margin-right: 74px;

                                        i.select {
                                            position: relative;
                                            width: 16px;
                                            height: 16px;
                                            border-radius: 2px;
                                            margin-right: 10px;
                                            background: url('./assets/select.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;

                                            &.on {
                                                background: url('./assets/selectOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }

                                        i.question {
                                            position: relative;
                                            width: 16px;
                                            height: 16px;
                                            margin-left: 4px;
                                            background: url('./assets/question.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            user-select: none;

                                            &:hover {
                                                .bg {
                                                    display: flex;
                                                }

                                                background: url('./assets/questionOn.png') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }

                                            .bg {
                                                position: absolute;
                                                left: -30px;
                                                top: -38px;
                                                display: none;
                                                align-items: center;
                                                justify-content: center;
                                                width: max-content;
                                                height: 32px;
                                                line-height: 32px;
                                                text-align: center;
                                                background: rgba(5,15,15,0.8);
                                                border-radius: 4px;
                                                font-size: 12px;
                                                color: #FFFFFF;
                                                font-weight: normal;
                                                padding: 0 10px;
                                                box-sizing: border-box;
                                            }
                                        }
                                    }

                                    .num {
                                        display: flex;
                                        align-items: center;
                                        margin-right: 20px;
                                        font-size: 14px;
                                        line-height: 20px;
                                        font-weight: bold;
                                        color: #050F0F;

                                        input {
                                            width: 36px;
                                            height: 32px;
                                            background: #F3F5F6;
                                            border-radius: 2px;
                                            outline: none;
                                            margin-right: 10px;
                                            text-align: center;
                                        }
                                    }

                                    p.tips {
                                        font-size: 13px;
                                        line-height: 18px;
                                        color: #829191;

                                        &::before {
                                            display: inline-block;
                                            content: '*';
                                            font-size: 13px;
                                            line-height: 18px;
                                            color: #FF5456;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btns {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 24px;

                .btn {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #FFFFFF;
                    user-select: none;
                    cursor: pointer;
                    font-weight: bold;

                    &.g {
                        background: #41B48C;
                        margin-right: 20px;
                    }
                }
            }
        }
    }
</style>